"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Statistic["default"];
  }
});
var _Statistic = _interopRequireDefault(require("./Statistic"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }